
import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
const state = {
    carritos:[]
};
const getters = {
};
const actions = {
    addItem(context, item) {
        context.commit("ADD_Item", item);
    },
    editItem(context, item, index) {
        context.commit("EDIT_Item", item, index);
    },
    removeItem(context, index) {
        context.commit("REMOVE_Item", index);
    },
};
const mutations = {
    ADD_Item(state, item) {
        state.carritos.push(item);
    },
    EDIT_Item(state, item, index) {
        state.carritos.splice(index, item);
    },
    REMOVE_Item(state, index) {
        state.carritos.splice(index, 1);
    },
};

export default{
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};